import DashboardContainer from './dashboard_container';

const Dashboard = DashboardContainer;
export default Dashboard;
